"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ExperimentContext_1 = __importDefault(require("./ExperimentContext"));
var services_1 = require("../services");
var RegisterExperiment_1 = __importDefault(require("./RegisterExperiment"));
var Experiment = /** @class */ (function (_super) {
    __extends(Experiment, _super);
    function Experiment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isPastDelay: false
        };
        _this.updateState = function (state) { return _this.setState(state); };
        return _this;
    }
    Experiment.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, updateExperiment = _a.updateExperiment, loadingDelay = _a.loadingDelay;
        if (typeof loadingDelay === 'number') {
            if (loadingDelay === 0) {
                this.updateState({ isPastDelay: true });
            }
            else {
                this.delaying = setTimeout(function () {
                    _this.updateState({ isPastDelay: true });
                }, loadingDelay);
            }
        }
        RegisterExperiment_1.default(this.props, updateExperiment);
    };
    Experiment.prototype.componentWillUnmount = function () {
        clearTimeout(this.delaying);
    };
    Experiment.prototype.render = function () {
        var _a = this.props, loading = _a.loading, children = _a.children, name = _a.name, experiments = _a.experiments, defaultBucket = _a.defaultBucket, renderDefaultOnServer = _a.renderDefaultOnServer, serverCookies = _a.serverCookies, updateExperiment = _a.updateExperiment;
        var isPastDelay = this.state.isPastDelay;
        var _b = (experiments[name] || {}).isLoading, isLoading = _b === void 0 ? true : _b;
        var showLoading = !!(isLoading && loading && isPastDelay);
        if (showLoading && typeof loading === 'string' && experiments[name]) {
            experiments[name].assignedBucket = loading;
            experiments[name].isLoading = false;
        }
        if (services_1.IsServerSideRendering() && !experiments[name]) {
            var assignedBucket = serverCookies[name] || (renderDefaultOnServer ? defaultBucket : '');
            experiments[name] = { assignedBucket: assignedBucket };
        }
        var providerContext = {
            experiments: experiments,
            currentExperiment: name,
            updateExperiment: updateExperiment
        };
        return (react_1.default.createElement(ExperimentContext_1.default.Provider, { value: providerContext }, showLoading && typeof loading !== 'string' ? loading : react_1.default.createElement(react_1.default.Fragment, null, children)));
    };
    Experiment.defaultProps = {
        experiments: {},
        defaultBucket: 'control',
        renderDefaultOnServer: true,
        serverCookies: {},
        updateExperiment: function () { },
        loadingDelay: 0
    };
    return Experiment;
}(react_1.PureComponent));
exports.default = Experiment;
